import React, { useEffect, useState } from "react";
import UnclaimedDraftEmbeddedSigning from "components/lib/Shared/ESignature/UnclaimedDraftEmbeddedSigning";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { convertOfficialDetailsToSignerDetails } from "utils/esignature";
import { Constants } from "config/constants";

/**
 * ChangeDocumentESignature component handles the e-signature flow for a change document row.
 * It prepares the signer details and file URLs for the UnclaimedDraftEmbeddedSigning component.
 *
 * Props:
 * - row: The data row containing the official and document info
 */
const OfficialDocESignature = ({
  official,
  isLastStep,
  goToNextStep,
  handleConfirmDetails,
}) => {
  // State for signers and file URLs
  const [signers, setSigners] = useState([]);

  // Prepare metadata and callback functions (extend as needed)
  const metadata = {
    individualId: official?._id,
    fileNames: ["changeDocumentPdf"],
  };
  let functionsToCall = [goToNextStep];

  if (isLastStep) {
    functionsToCall.push(handleConfirmDetails);
  }

  let documentUrls = [];

  if (official?.changeType === Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT) {
    if (
      official?.uploadChangeDocuments?.appointment?.consentToAct?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.appointment?.consentToAct?.convertedPdf}`
      );
    }
    if (
      official?.uploadChangeDocuments?.appointment?.appointmentLetter
        ?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.appointment?.appointmentLetter?.convertedPdf}`
      );
    }
  }

  if (official?.changeType === Constants.TRANSACTION_CHANGE_TYPES.CESSATION) {
    if (
      official?.uploadChangeDocuments?.cessation?.letterOfResignation
        ?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.cessation?.letterOfResignation?.convertedPdf}`
      );
    }
    if (
      official?.uploadChangeDocuments?.cessation?.statutoryDeclaration
        ?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.cessation?.statutoryDeclaration?.convertedPdf}`
      );
    }
  }

  if (
    official?.changeType ===
    Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_PARTICULARS
  ) {
    if (
      official?.uploadChangeDocuments?.changeOfParticulars?.deedPoll
        ?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.changeOfParticulars?.deedPoll?.convertedPdf}`
      );
    }
    if (
      official?.uploadChangeDocuments?.changeOfParticulars?.statutoryDeclaration
        ?.convertedPdf
    ) {
      documentUrls.push(
        `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${official?.uploadChangeDocuments?.changeOfParticulars?.statutoryDeclaration?.convertedPdf}`
      );
    }
  }

  // Helper to get the signing details for the stakeholder
  const getStakeholderSigningDetails = () =>
    convertOfficialDetailsToSignerDetails(official);

  // Set up signers and file URLs on mount
  useEffect(() => {
    setSigners([getStakeholderSigningDetails()]);
  }, []);

  // Render the signing UI if data is ready, otherwise show a loading spinner
  if (signers.length > 0 && documentUrls.length > 0) {
    return (
      <div>
        <UnclaimedDraftEmbeddedSigning
          signers={signers}
          fileUrls={documentUrls}
          metadata={metadata}
          functionsToCall={functionsToCall}
        />
      </div>
    );
  }

  return (
    <div>
      <h1>
        <SpinnerIcon /> Getting details ...
      </h1>
    </div>
  );
};

export default OfficialDocESignature;
